// Education Department, Bihar page loader, shared by every loading state in the
// app: the notiflix helpers (components/ui/notification), <Loader />, route
// code-splitting fallbacks and the SSO landing page.
import biharLogo from '../../../assets/images/bihar-logo-red.png';
import './brandLoader.css';

// ---- Education Department, Bihar loader ------------------------------------
// One overlay element, created on first use. It appears only if loading takes
// longer than SHOW_DELAY, so quick requests don't flash it.
const SHOW_DELAY = 150;
let overlay = null;
let showTimer = null;

const ensureOverlay = () => {
    if (overlay || typeof document === 'undefined') return overlay;
    overlay = document.createElement('div');
    overlay.className = 'bl-overlay';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.innerHTML = `
        <div class="bl-card">
            <div class="bl-book" aria-hidden="true">
                <span class="bl-book__cover bl-book__cover--l"></span>
                <span class="bl-book__cover bl-book__cover--r"></span>
                <span class="bl-book__page bl-book__page--l"></span>
                <span class="bl-book__page bl-book__page--r"></span>
                <span class="bl-book__turns">
                    <span class="bl-book__page bl-book__page--turn"></span>
                    <span class="bl-book__page bl-book__page--turn"></span>
                    <span class="bl-book__page bl-book__page--turn"></span>
                </span>
                <span class="bl-book__spine"></span>
            </div>
            <div class="bl-caption"><img src="${biharLogo}" alt="" />शिक्षा विभाग, बिहार</div>
            <div class="bl-sub"><span class="bl-dots">Please wait</span> · कृपया प्रतीक्षा करें</div>
        </div>`;
    document.body.appendChild(overlay);
    return overlay;
};

export const showLoader = () => {
    clearTimeout(showTimer);
    showTimer = setTimeout(() => {
        const el = ensureOverlay();
        if (el) el.classList.add('is-visible');
    }, SHOW_DELAY);
};

export const hideLoader = () => {
    clearTimeout(showTimer);
    if (overlay) overlay.classList.remove('is-visible');
};
